import en from './en/translation.json'
import de from './de/translation.json'
import es from './es/translation.json'
import fr from './fr/translation.json'
import it from './it/translation.json'
import pl from './pl/translation.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
    en: {
        translation: en,
    },
    de: {
        translation: de
    },
    fr: {
        translation: fr
    },
    it: {
        translation: it
    },
    pl: {
        translation: pl
    },
    es: {
        translation: es
    }
}
i18n
    .use(initReactI18next).init({
        resources,
        fallbackLng: 'en',
        react: {
          useSuspense: false
        },
        interpolation: {
          escapeValue: false
        }
    })

export { en, de, es, fr, it, pl, i18n }